<ngx-extended-pdf-viewer
  [enablePrint]="printAllowed"
  [showPrintButton]="printAllowed"
  [showDownloadButton]="downloadAllowed"
  [showOpenFileButton]="false"
  [showDrawEditor]="false"
  [showStampEditor]="false"
  [showTextEditor]="false"
  [showHighlightEditor]="false"
  [src]="blob"
  [language]='selectedLanguage'
  (pageChange)="pageChanged($event)"
  (currentZoomFactor)='zoomChanged($event)'
>
</ngx-extended-pdf-viewer>
